import React from 'react';
// import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import CorrespondanceNewMessage from './correspondance_new_message/CorrespondanceNewMessage';
import CorrespondanceFeed from './correspondance_feed/CorrespondanceFeed';

const defaultCorType = {
  ['ANNOUNCEMENTS']: true,
  ['COMMENTS']: true,
  ['LOGS']: true,
  ['DIALPAD_SMS_TEXT']: true,
  ['DIALPAD_CALL_TRANSCRIPT']: true,
  ['EMAIL']: true,
};

const Correspondances = (props) => {
  const [corType, setCorType] = React.useState(defaultCorType);
  const [sortDir, setSortDir] = React.useState('DESC');

  return (
    <Stack>
      <CorrespondanceNewMessage
        corType={corType}
        setCorType={setCorType}
        sortDir={sortDir}
        setSortDir={setSortDir}
        {...props}
      />
      <CorrespondanceFeed
        corType={corType}
        sortDir={sortDir}
        {...props}
      />
    </Stack>
  );
};
Correspondances.propTypes = {
};

export default React.memo(Correspondances);
